export default "__VITE_ASSET__yNK35tod__"